import { AxiosApi, ApiResult } from './axiosApi';
import { Box, BoxOwner } from '../dtos/box';
import { ExportResult } from '../dtos/export';
import { Event } from '../dtos/event';
import { BoxesFilterRequest } from './requestObjects/boxesRequest';
import { LogFilterRequest } from './requestObjects/eventLogRequest';

export class BoxApi extends AxiosApi<Box> {
    constructor(baseUri: string, logout?: () => void, enqueueSnackbar?: any) {
        super(baseUri, 'boxes', logout, enqueueSnackbar);
    }

    public getBoxesForSite = (
        orgId: number,
        siteId: number,
        options: BoxesFilterRequest,
        abortController?: AbortController
    ) =>
        this.genericRequest({
            method: 'POST',
            data: options,
            abortController,
            overridePath: `organizations/${orgId}/sites/${siteId}/${this._resourceName}`,
        }) as Promise<ApiResult<{ boxes: Box[]; numberOfPages: number }>>;

    public getBoxesReportForSite = (
        orgId: number,
        siteId: number,
        request: BoxesFilterRequest,
        abortController?: AbortController
    ) =>
        this.genericRequest({
            method: 'POST',
            data: request,
            overridePath: `organizations/${orgId}/sites/${siteId}/boxesreport`,
            abortController,
        }) as Promise<ApiResult<ExportResult>>;

    public getOwners = (boxId: number) =>
        this.genericRequest({ method: 'GET', extraPath: `${boxId}/owners` }) as Promise<
            ApiResult<BoxOwner[]>
        >;

    public addOwner = (
        boxId: number,
        ownerId: number,
        leaseEndDate: string | null,
        setLeaseEndDate: boolean,
    ) =>
        this.genericRequest({
            method: 'POST',
            extraPath: `${boxId}/addOwner`,
            data: { ownerId, leaseEndDate, setLeaseEndDate },
        }) as Promise<ApiResult<null>>;

    public removeOwner = (boxId: number, ownerId: number) =>
        this.genericRequest({
            method: 'DELETE',
            extraPath: `${boxId}/owner/${ownerId}`,
        }) as Promise<ApiResult<null>>;

    public setNotes = (boxId: number, notes: string) =>
        this.genericRequest({
            method: 'PUT',
            extraPath: `${boxId}/notes`,
            data: { notes },
        }) as Promise<ApiResult<null>>;

    public deleteCurrentLease = (boxId: number) =>
        this.genericRequest({
            method: 'DELETE',
            extraPath: `${boxId}/lease`,
        });

    public getBoxFilterOptions = (availableOnly: boolean, orgId: number, siteId: number) =>
        this.genericRequest({
            method: 'GET',
            overridePath: `organizations/${orgId}/sites/${siteId}/boxes/filterOptions${!!availableOnly ? '?availableOnly=true' : ''
                }`,
        }) as Promise<ApiResult<{ locations: string[]; sizes: string[] }>>;

    public setIsBankBox = (boxId: number, isBankBox: boolean) =>
        this.genericRequest({
            method: 'PUT',
            extraPath: `${boxId}/bank-box`,
            data: { isBankBox },
        }) as Promise<ApiResult<null>>;

    public getEvents = (boxId: number, request: LogFilterRequest, abortController?: AbortController) =>
        this.genericRequest({
            method: 'POST',
            data: request,
            extraPath: `${boxId}/events`,
            abortController,
        }) as Promise<ApiResult<{ numberOfPages: number; events: Event[] }>>;
}
